export default __webpack_public_path__ + "static/media/its-on.a069bc65.gif";